import Glide, { Swipe } from '@glidejs/glide/dist/glide.modular.esm'

const MAX_PER_VIEW = 4

export default function InitAnsprechpartnerModule() {
    document.querySelectorAll('[data-ansprechpartner-slider]').forEach((sliderEl) => {
        // nothing to slide (e.g. collection still empty while editing) — skip
        // mounting glide entirely rather than risk it erroring on 0 slides
        if (!sliderEl.querySelector('.glide__slide')) {
            return
        }

        const root = sliderEl.closest('.ansprechpartner')
        const controls = sliderEl.querySelector('[data-ansprechpartner-controls]')
        const cards = root.querySelectorAll('[data-ansprechpartner-card]')

        // fewer contacts than fit in a row — lay them out as a static,
        // wrapping grid instead of mounting glide. glide's "carousel" type
        // clones slides to fill up the perView slots when there are fewer
        // real slides than that, which visually repeats a single card
        // several times — skipping glide entirely avoids that altogether.
        if (cards.length <= MAX_PER_VIEW) {
            sliderEl.classList.add('ansprechpartner__slider--static')
            if (controls) {
                controls.style.display = 'none'
            }
        } else {
            const prevButton = sliderEl.querySelector('[data-ansprechpartner-prev]')
            const nextButton = sliderEl.querySelector('[data-ansprechpartner-next]')

            const getSliderSettings = () => {
                // 1-per-row below 480px, 2-per-row from 480px to 767px,
                // 3-per-row from 768px up to (not including) the 1200px
                // desktop tier, which stays at MAX_PER_VIEW (4) — matches
                // the static grid's breakpoints in AnsprechpartnerModule.scss
                if (window.matchMedia('(max-width: 480px)').matches) {
                    return { perView: 1, gap: 16 }
                }
                if (window.matchMedia('(max-width: 767px)').matches) {
                    return { perView: 2, gap: 16 }
                }
                if (window.matchMedia('(max-width: 1199px)').matches) {
                    return { perView: 3, gap: 24 }
                }
                return { perView: MAX_PER_VIEW, gap: 24 }
            }

            const sliderSettings = getSliderSettings()

            // no loop (client request, applies to every slider on the
            // site) — "slider" + bound:true stops firmly at the last
            // slide instead of "carousel"/rewind wrapping back to the start
            const glide = new Glide(sliderEl, {
                type: 'slider',
                bound: true,
                // glide.js defaults "rewind" to true even for "slider"
                // type — without this it silently wraps around
                rewind: false,
                perView: sliderSettings.perView,
                gap: sliderSettings.gap,
                animationDuration: 400,
                // Neos.Neos:ContentCollection wraps the cards in its own
                // ".neos-contentcollection" div — treat it as the slides track
                classes: { slides: 'neos-contentcollection' },
            })

            const updateArrows = () => {
                prevButton?.classList.toggle('is-disabled', glide.index === 0)
                nextButton?.classList.toggle('is-disabled', glide.index + glide.settings.perView >= cards.length)
            }

            if (prevButton) {
                prevButton.addEventListener('click', () => glide.go('<'))
            }

            if (nextButton) {
                nextButton.addEventListener('click', () => glide.go('>'))
            }

            glide.on(['mount.after', 'run'], updateArrows)
            glide.mount({ Swipe })

            window.addEventListener('resize', () => {
                const nextSettings = getSliderSettings()
                glide.update({ perView: nextSettings.perView, gap: nextSettings.gap })
            })
        }

        // touch devices have no :hover — tapping a card toggles the same
        // "flipped to contact info" state instead. Tapping a link inside the
        // flipped card (tel:/mailto:/xing/linkedin) still has to work, so we
        // only intercept the tap when the card isn't already flipped.
        if (document.body.classList.contains('touch-device')) {
            cards.forEach((card) => {
                card.addEventListener('click', (event) => {
                    if (!card.classList.contains('is-flipped')) {
                        event.preventDefault()
                        cards.forEach((other) => other.classList.toggle('is-flipped', other === card))
                    }
                })
            })

            document.addEventListener('click', (event) => {
                if (!root.contains(event.target)) {
                    cards.forEach((card) => card.classList.remove('is-flipped'))
                }
            })
        }
    })
}
